import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { IThankingPopupInputs } from '@shared/interfaces';

@Component({
  selector: 'el-base-neo-thanking-page',
  templateUrl: './thanking-page.component.html',
  styleUrls: ['./thanking-page.component.scss'],
  standalone: false,
})
export class ThankingPageComponent {
  data: IThankingPopupInputs;
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.data = {
        title: params.get('title'),
        sub_title: params.get('sub_title'),
      };
    });
  }

  onReturn() {
    this.router.navigate(['']);
  }
}
